$(document).ready(function(){
  BrushSlide();
  Artist_choise();
  Testimonial();
   
  
});

$(window).load(function(){

  
  
 
   
});

$(window).resize(function(){
 
    
 
});





equalheight = function(container){

var currentTallest = 0,
     currentRowStart = 0,
     rowDivs = new Array(),
     $el,
     topPosition = 0;
 $(container).each(function() {

   $el = $(this);
   $($el).height('auto')
   topPostion = $el.position().top;

   if (currentRowStart != topPostion) {
     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
       rowDivs[currentDiv].height(currentTallest);
     }
     rowDivs.length = 0; // empty the array
     currentRowStart = topPostion;
     currentTallest = $el.height();
     rowDivs.push($el);
   } else {
     rowDivs.push($el);
     currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
  }
   for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
     rowDivs[currentDiv].height(currentTallest);
   }
 });
}



// brushe Slider Home Page
function BrushSlide(){
  if($('.brushes.product_slider').length > 0){
    $('.brushes.product_slider').slick({
    dots: false,
    arrows:true,
    infinite: true,
    speed:1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
     autoplaySpeed:3000,
     nextArrow: "<button type='button' class='trans slick-next slickarrow'><svg viewBox='0 0 7 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M0.352369 13.5193C0.132699 13.2997 0.132699 12.9435 0.352369 12.7238L5.24237 7.83383C5.6002 7.476 5.6002 6.88716 5.24237 6.52933L0.35237 1.63933C0.1327 1.41966 0.1327 1.0635 0.35237 0.843832C0.57204 0.624163 0.928195 0.624163 1.14787 0.843832L6.03787 5.73383C6.83504 6.531 6.83504 7.83216 6.03787 8.62933L1.14786 13.5193C0.928194 13.739 0.572039 13.739 0.352369 13.5193Z' fill='currentColor'/></svg></button>",
    prevArrow: "<button type='button' class='trans slick-prev slickarrow'><svg viewBox='0 0 7 14' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M6.64775 0.662311C6.86742 0.881981 6.86742 1.23814 6.64775 1.45781L1.75775 6.34781C1.39992 6.70564 1.39992 7.29448 1.75775 7.65231L6.64775 12.5423C6.86742 12.762 6.86742 13.1181 6.64775 13.3378C6.42808 13.5575 6.07193 13.5575 5.85226 13.3378L0.962257 8.44781C0.165087 7.65064 0.165087 6.34948 0.962257 5.55231L5.85226 0.662311C6.07193 0.442641 6.42808 0.442641 6.64775 0.662311Z' fill='currentColor'/></svg></button>",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      }
      ] 
  });
  }
}

// Artitst slider Home Page
function Artist_choise(){
  if($('.artitst_slider').length > 0){
    $('.artitst_slider').slick({
    dots: true,
    arrows:false,
    infinite: true,
    speed:1000,
    slidesToShow: 4,
    slidesToScroll: 4,
     autoplay: true,
     autoplaySpeed:5000,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
        {
        breakpoint: 749,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true
        }
      }
      ] 
  });
  }
}


// Testimonial slider Home Page
function Testimonial(){
  if($('.testimonial_slider_main').length > 0){
    $('.testimonial_slider_main').slick({
    dots: true,
    arrows:false,
    infinite: true,
    speed:1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed:3000,
   
  });
  }
}

// Pop JS Start

$(document).ready(function(){

		$(window).load(function(){
			$duration = 15;
			$('.seconds').text($duration);
			$('.popup-wrap').fadeIn(1500);

			$myTimer = setInterval(function(){ startTimer() }, 1000);
			$('.popup .btn-close').on("click",function(){
				clearInterval($myTimer);
				$('.popup-wrap').fadeOut(500);
			});
			
			function startTimer(){
				$duration--;
				$('.seconds').text($duration);
				if($duration==0){
					clearInterval($myTimer);
					$('.popup-wrap').fadeOut(500);
				}
			}
		});
	});
